/* eslint-disable */
import Icon from 'acud-icon';
import React from 'react';

const pieEmptySvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54"><g fill="none" fill-rule="evenodd"><path d="M-10-8h72v72h-72z"/><path fill="#E8E9EB" d="M52 28c0 14.36-11.64 26-26 26S0 42.36 0 28 11.64 2 26 2v26Z"/><path fill="#D4D6D9" d="M28 0c14.36 0 26 11.64 26 26H28Z"/><path d="M-10-8h72v72h-72z"/></g></svg>
);
export default (props: {
    width?: number;
    height?: number
}) => {
    const {width, height} = props;
    return <Icon {...{width, height}} component={pieEmptySvg} />;
}